import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2496 2496"
      id="vector">
      <g
        id="group"
        transform="translate(53 57)">
        <path
          id="path"
          d="M 2291.5 21 L 2292.5 23 L 2291.5 21 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 38.5 23 L 36.5 26 L 38.5 23 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 2297.5 26 L 2306.5 36 L 2297.5 26 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 25.5 36 L 24.5 38 L 25.5 36 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 21.5 41 L 20.5 43 L 21.5 41 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 82.5 76 L 77.5 82 L 82.5 76 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 0.5 96 L 1 99.5 L 0 99.5 L 0.5 96 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 2332.5 96 L 2333 100.5 L 2332 100.5 L 2332.5 96 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 69.5 101 L 70 2232.5 L 69 2232.5 L 69.5 101 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 2263.5 101 L 2264 199.5 L 2263 199.5 L 2263.5 101 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 2151.5 188 L 2153.5 191 L 2151.5 188 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 2162.5 213 L 2163 1920.5 L 2162 1920.5 L 2162.5 213 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 1081.5 340 L 1252 340.5 L 1081.5 341 L 1081.5 340 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 1288.5 355 L 1293.5 361 L 1288.5 355 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 1043.5 356 L 1040.5 360 L 1043.5 356 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 1437.5 398 L 1443.5 405 L 1437.5 398 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 894.5 399 L 890.5 404 L 894.5 399 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 1456.5 433 L 1457 435.5 L 1456 435.5 L 1456.5 433 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 876.5 434 L 877 437.5 L 876 437.5 L 876.5 434 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 1446.5 573 L 1445.5 575 L 1446.5 573 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 888.5 574 L 890.5 577 L 888.5 574 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 895.5 581 L 897.5 584 L 895.5 581 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 1436.5 583 L 1435.5 585 L 1436.5 583 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1292.5 662 L 1289.5 666 L 1292.5 662 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 1048.5 668 L 1049.5 670 L 1048.5 668 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 1255.5 680 L 1258 680.5 L 1255.5 681 L 1255.5 680 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 1132.5 681 L 1133 738.5 L 1132 738.5 L 1132.5 681 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 1201.5 681 L 1202 739.5 L 1201 739.5 L 1201.5 681 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 1192.5 759 L 1190.5 762 L 1192.5 759 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 1162.5 770 L 1165 770.5 L 1162.5 771 L 1162.5 770 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 1169.5 770 L 1172 770.5 L 1169.5 771 L 1169.5 770 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 733.5 1004 L 732.5 1006 L 733.5 1004 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 1600.5 1004 L 1601.5 1006 L 1600.5 1004 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 1604.5 1007 L 1606.5 1010 L 1604.5 1007 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 728.5 1008 L 727.5 1010 L 728.5 1008 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 1132.5 1209 L 1133 1391.5 L 1131 1392.5 L 1132 1391.5 L 1132.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 1201.5 1209 L 1202 1391.5 L 1203 1392.5 L 1201 1391.5 L 1201.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 1132.5 1466 L 1133 1670 L 1131 1669.5 L 1132 1668.5 L 1132.5 1466 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 1201.5 1466 L 1202 1669.5 L 1201 1669.5 L 1201.5 1466 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 727.5 1591 L 729.5 1594 L 727.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 1606.5 1591 L 1604.5 1594 L 1606.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 733.5 1596 L 734.5 1598 L 733.5 1596 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 440.5 1685 L 443 1685.5 L 440.5 1686 L 440.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 1892.5 1685 L 1895 1685.5 L 1892.5 1686 L 1892.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 392.5 1704 L 391.5 1706 L 392.5 1704 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 1944.5 1706 L 1946.5 1709 L 1944.5 1706 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 386.5 1709 L 381.5 1715 L 386.5 1709 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 1954.5 1716 L 1956.5 1719 L 1954.5 1716 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 1900.5 1760 L 1901.5 1762 L 1900.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 1977.5 1769 L 1978 1771.5 L 1977 1771.5 L 1977.5 1769 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 425.5 1774 L 426 1886 L 1908 1886.5 L 426.5 1887 L 425 1885.5 L 425.5 1774 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 240.5 1886 L 357 1886.5 L 240.5 1887 L 240.5 1886 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 1978.5 1886 L 2094 1886.5 L 1978.5 1887 L 1978.5 1886 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 179.5 1943 L 183.5 1948 L 179.5 1943 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 201.5 1955 L 204 1955.5 L 201.5 1956 L 201.5 1955 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 482.5 2107 L 485 2107.5 L 482.5 2108 L 482.5 2107 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 1849.5 2107 L 1852 2107.5 L 1849.5 2108 L 1849.5 2107 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 2263.5 2134 L 2264 2232.5 L 2263 2232.5 L 2263.5 2134 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 1924.5 2135 L 1925.5 2137 L 1924.5 2135 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 408.5 2136 L 407.5 2138 L 408.5 2136 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 1929.5 2139 L 1931.5 2142 L 1929.5 2139 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 402.5 2141 L 391.5 2153 L 402.5 2141 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 1942.5 2152 L 1944.5 2155 L 1942.5 2152 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 387.5 2157 L 386.5 2159 L 387.5 2157 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 451.5 2190 L 450.5 2192 L 451.5 2190 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 1882.5 2190 L 1883.5 2192 L 1882.5 2190 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 442.5 2199 L 441.5 2201 L 442.5 2199 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 1891.5 2199 L 1892.5 2201 L 1891.5 2199 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 0.5 2233 L 1 2237.5 L 0 2237.5 L 0.5 2233 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 2332.5 2233 L 2333 2237.5 L 2332 2237.5 L 2332.5 2233 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 1988.5 2242 L 1993.5 2248 L 1988.5 2242 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 1931.5 2282 L 1932.5 2284 L 1931.5 2282 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 400.5 2284 L 398.5 2287 L 400.5 2284 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 1936.5 2288 L 1947.5 2300 L 1936.5 2288 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 26.5 2298 L 35.5 2308 L 26.5 2298 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 2306.5 2298 L 2297.5 2308 L 2306.5 2298 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 383.5 2301 L 381.5 2304 L 383.5 2301 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 1952.5 2303 L 1953.5 2305 L 1952.5 2303 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 40.5 2311 L 41.5 2313 L 40.5 2311 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 2292.5 2311 L 2291.5 2313 L 2292.5 2311 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 305.5 2333 L 308 2333.5 L 305.5 2334 L 305.5 2333 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 2025.5 2333 L 2028 2333.5 L 2025.5 2334 L 2025.5 2333 Z"
          fill="currentColor"
          fillOpacity="0.2705882"
          stroke="currentColor"
          strokeOpacity="0.2705882"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 95.5 0 L 98 0.5 L 95.5 1 L 95.5 0 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 2178.5 0 L 2233 0.5 L 2178.5 1 L 2178.5 0 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 40.5 22 L 39.5 24 L 40.5 22 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 2294.5 24 L 2295.5 26 L 2294.5 24 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 32.5 29 L 30.5 32 L 32.5 29 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 2307.5 37 L 2308.5 39 L 2307.5 37 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 2255.5 81 L 2256.5 83 L 2255.5 81 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 183.5 188 L 179.5 193 L 183.5 188 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 1285.5 353 L 1286.5 355 L 1285.5 353 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 1046.5 354 L 1045.5 356 L 1046.5 354 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 1040.5 360 L 1039.5 362 L 1040.5 360 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 1293.5 361 L 1294.5 363 L 1293.5 361 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 1435.5 397 L 1436.5 399 L 1435.5 397 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 896.5 398 L 895.5 400 L 896.5 398 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 1094.5 409 L 1095 611.5 L 1094 611.5 L 1094.5 409 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 945.5 454 L 946 526 L 1026 526.5 L 946.5 527 L 945 525.5 L 945.5 454 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 2332.5 459 L 2333 487.5 L 2332 487.5 L 2332.5 459 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 240.5 525 L 877 525.5 L 240.5 526 L 240.5 525 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 1457.5 525 L 2094 525.5 L 1457.5 526 L 1457.5 525 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 1307.5 526 L 1388 526.5 L 1307.5 527 L 1307.5 526 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 877.5 543 L 878 546.5 L 877 546.5 L 877.5 543 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 1456.5 545 L 1457 547.5 L 1456 547.5 L 1456.5 545 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 1442.5 577 L 1439.5 581 L 1442.5 577 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 925.5 594 L 928 594.5 L 925.5 595 L 925.5 594 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 1406.5 594 L 1409 594.5 L 1406.5 595 L 1406.5 594 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 1026.5 624 L 1027 627.5 L 1026 627.5 L 1026.5 624 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 1307.5 626 L 1308 628.5 L 1307 628.5 L 1307.5 626 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 1036.5 655 L 1037.5 657 L 1036.5 655 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 1294.5 659 L 1293.5 661 L 1294.5 659 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 1040.5 660 L 1046.5 667 L 1040.5 660 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 1288.5 665 L 1287.5 667 L 1288.5 665 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 1283.5 669 L 1282.5 671 L 1283.5 669 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 1082.5 680 L 1133 680.5 L 1082.5 681 L 1082.5 680 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 1201.5 680 L 1252 680.5 L 1201.5 681 L 1201.5 680 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 1140.5 757 L 1141.5 759 L 1140.5 757 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 1144.5 761 L 1145.5 763 L 1144.5 761 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 719.5 1028 L 720 1572.5 L 719 1572.5 L 719.5 1028 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 1614.5 1028 L 1615 1572.5 L 1614 1572.5 L 1614.5 1028 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 1481.5 1567 L 1480.5 1569 L 1481.5 1567 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 1607.5 1589 L 1606.5 1591 L 1607.5 1589 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 1603.5 1593 L 1602.5 1595 L 1603.5 1593 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 394.5 1703 L 393.5 1705 L 394.5 1703 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 389.5 1707 L 387.5 1710 L 389.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 380.5 1716 L 379.5 1718 L 380.5 1716 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 434.5 1758 L 433.5 1760 L 434.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 430.5 1762 L 429.5 1764 L 430.5 1762 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 357.5 1769 L 358 1772.5 L 357 1772.5 L 357.5 1769 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 178.5 1941 L 179.5 1943 L 178.5 1941 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 2153.5 1943 L 2150.5 1947 L 2153.5 1943 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 184.5 1947 L 185.5 1949 L 184.5 1947 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 1922.5 2134 L 1923.5 2136 L 1922.5 2134 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 1927.5 2138 L 1928.5 2140 L 1927.5 2138 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 405.5 2139 L 404.5 2141 L 405.5 2139 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 390.5 2154 L 389.5 2156 L 390.5 2154 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 487.5 2175 L 491 2175.5 L 487.5 2176 L 487.5 2175 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 1843.5 2175 L 1847 2175.5 L 1843.5 2176 L 1843.5 2175 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 449.5 2191 L 447.5 2194 L 449.5 2191 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 1885.5 2192 L 1890.5 2198 L 1885.5 2192 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 444.5 2196 L 442.5 2199 L 444.5 2196 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 439.5 2202 L 438.5 2204 L 439.5 2202 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 1985.5 2239 L 1986.5 2241 L 1985.5 2239 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 76.5 2251 L 77.5 2253 L 76.5 2251 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 2256.5 2251 L 2255.5 2253 L 2256.5 2251 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 401.5 2282 L 400.5 2284 L 401.5 2282 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 1934.5 2285 L 1935.5 2287 L 1934.5 2285 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 395.5 2289 L 386.5 2299 L 395.5 2289 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 24.5 2295 L 25.5 2297 L 24.5 2295 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 2308.5 2295 L 2307.5 2297 L 2308.5 2295 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 1949.5 2300 L 1950.5 2302 L 1949.5 2300 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 380.5 2303 L 379.5 2305 L 380.5 2303 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 37.5 2308 L 38.5 2310 L 37.5 2308 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 2295.5 2308 L 2294.5 2310 L 2295.5 2308 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 100.5 2333 L 301 2333.5 L 100.5 2334 L 100.5 2333 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 2033.5 2333 L 2138 2333.5 L 2033.5 2334 L 2033.5 2333 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 2214.5 2333 L 2233 2333.5 L 2214.5 2334 L 2214.5 2333 Z"
          fill="currentColor"
          fillOpacity="0.7960784"
          stroke="currentColor"
          strokeOpacity="0.7960784"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 98.5 0 L 2177.5 0 L 2178.5 1 L 2240.5 1 Q 2284 8.6 2307 36.5 Q 2320.9 52.1 2328 74.5 L 2332 94.5 L 2332 117 L 2334 117.5 L 2334 437 L 2332 437.5 L 2332 487.5 L 2333 488.5 L 2333 2180.5 L 2332 2181.5 L 2332 2239.5 L 2328 2259.5 Q 2318.2 2289.7 2296.5 2308 Q 2283.9 2318.9 2267.5 2326 L 2247.5 2332 Q 2242 2330.5 2240.5 2333 L 2214.5 2333 L 2213.5 2334 L 2138.5 2334 L 2137.5 2333 L 2023.5 2333 L 2022.5 2332 L 2010.5 2331 Q 1963 2319.5 1936 2287.5 Q 1925 2275 1917 2259.5 L 1907 2233.5 L 1906 2225.5 L 1903 2216.5 L 1899 2208.5 L 1885.5 2192 L 1866.5 2180 L 1846.5 2175 L 487.5 2175 L 472.5 2178 L 459.5 2184 L 442 2198.5 Q 434.5 2207 430 2218.5 L 423 2244.5 L 412 2267.5 Q 399.6 2288.1 381.5 2303 Q 367.1 2315.1 348.5 2323 L 331.5 2329 L 310.5 2333 L 92.5 2333 Q 49 2325.5 26 2297.5 Q 15.7 2285.8 9 2270.5 L 5 2259.5 L 1 2239.5 L 1 93.5 L 4 77.5 Q 8 63 15 51.5 Q 24.4 35.4 38.5 24 Q 50 14.5 64.5 8 L 83.5 2 L 97.5 1 L 98.5 0 Z M 101 68 Q 91 70 85 74 Q 73 82 69 98 L 69 2236 Q 71 2245 76 2252 Q 83 2262 98 2265 L 307 2265 Q 326 2261 339 2250 Q 348 2242 354 2232 L 358 2224 L 362 2208 L 371 2184 Q 379 2167 391 2154 Q 408 2134 432 2122 L 458 2112 L 480 2108 L 1855 2108 L 1856 2109 L 1863 2109 L 1873 2111 L 1892 2117 Q 1913 2126 1930 2140 Q 1947 2155 1959 2176 L 1968 2195 L 1976 2224 L 1985 2240 Q 1999 2259 2028 2265 L 2236 2265 L 2251 2258 Q 2261 2250 2264 2236 L 2264 2135 L 2265 2134 L 2265 201 L 2264 200 L 2264 99 Q 2262 89 2257 83 Q 2250 72 2236 69 L 2139 69 L 2138 68 L 101 68 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 202.5 180 L 2131.5 180 L 2144.5 184 L 2154 191.5 L 2160 201.5 L 2162 209.5 L 2162 1924.5 L 2159 1935.5 L 2147.5 1949 L 2133.5 1955 L 200.5 1955 Q 187.3 1952.2 180 1943.5 L 172 1927.5 L 172 208.5 Q 175.4 193.4 186.5 186 L 191.5 183 L 202.5 180 Z M 240 248 L 240 457 L 241 457 L 877 457 L 877 434 Q 879 432 878 428 Q 882 414 890 405 L 903 394 L 917 388 L 927 386 L 1027 386 L 1033 371 L 1041 360 L 1058 347 L 1065 344 L 1079 341 L 1255 341 L 1266 343 L 1274 346 L 1288 355 Q 1301 365 1305 385 L 1307 386 L 1407 386 L 1421 389 L 1438 399 Q 1452 411 1456 433 L 1456 457 L 1457 457 L 2094 457 L 2094 249 L 2094 248 L 240 248 Z M 1094 409 L 1094 612 L 1240 612 L 1240 409 L 1094 409 Z M 945 454 L 945 526 L 947 527 L 1026 527 L 1026 454 L 945 454 Z M 1307 454 L 1307 527 L 1388 527 L 1388 454 L 1307 454 Z M 240 525 L 240 1887 L 241 1887 L 357 1887 L 357 1774 L 358 1773 L 358 1764 Q 364 1734 381 1716 L 403 1698 L 424 1689 L 439 1686 L 974 1686 L 741 1600 L 731 1594 Q 723 1588 720 1577 L 720 1026 L 728 1010 L 737 1003 L 747 999 L 1161 848 Q 1173 847 1181 850 L 1468 956 L 1580 996 L 1596 1002 L 1605 1008 Q 1611 1014 1614 1025 L 1614 1577 L 1606 1592 L 1594 1600 L 1387 1675 L 1361 1686 L 1897 1686 L 1920 1692 Q 1933 1698 1944 1706 Q 1959 1718 1968 1737 L 1975 1756 L 1977 1767 L 1977 1887 L 2094 1887 L 2094 525 L 1457 525 L 1456 552 Q 1453 565 1446 574 Q 1435 589 1414 594 Q 1407 592 1406 595 L 1308 595 L 1308 626 Q 1305 627 1307 634 Q 1303 650 1293 662 Q 1282 674 1264 679 L 1259 680 L 1201 680 L 1201 742 Q 1199 752 1193 759 Q 1186 767 1173 770 Q 1152 771 1144 761 Q 1135 754 1133 741 L 1133 680 L 1076 680 Q 1060 677 1050 669 Q 1034 658 1028 638 L 1027 625 L 1026 624 L 1026 595 L 929 595 L 914 592 L 898 583 Q 889 576 883 566 L 880 559 L 877 543 L 877 526 L 877 525 L 240 525 Z M 1166 918 L 857 1031 L 853 1034 L 1167 1149 L 1481 1034 L 1470 1028 L 1339 981 L 1298 965 Q 1235 944 1175 920 L 1166 918 Z M 788 1082 L 787 1519 L 1132 1393 L 1133 1393 L 1133 1208 L 799 1087 L 788 1082 Z M 1546 1082 L 1204 1208 L 1201 1209 L 1201 1393 L 1546 1518 L 1547 1519 L 1547 1083 L 1546 1082 Z M 1132 1465 L 855 1567 Q 852 1566 853 1569 L 1132 1670 L 1133 1671 L 1133 1466 L 1132 1465 Z M 1201 1465 L 1202 1671 L 1476 1571 L 1482 1568 L 1201 1465 Z M 443 1754 L 435 1758 Q 427 1763 425 1773 L 425 1887 L 426 1887 L 1908 1887 L 1908 1772 L 1904 1764 Q 1899 1757 1891 1754 L 443 1754 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 35.5 26 L 33.5 29 L 35.5 26 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 29.5 32 L 27.5 35 L 29.5 32 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 2251.5 77 L 2254.5 81 L 2251.5 77 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 1444.5 575 L 1443.5 577 L 1444.5 575 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 891.5 577 L 894.5 581 L 891.5 577 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 1438.5 581 L 1437.5 583 L 1438.5 581 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 731.5 1006 L 730.5 1008 L 731.5 1006 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 1947.5 1709 L 1953.5 1716 L 1947.5 1709 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 432.5 1760 L 431.5 1762 L 432.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 1933.5 2143 L 1940.5 2151 L 1933.5 2143 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 446.5 2194 L 445.5 2196 L 446.5 2194 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 345.5 2242 L 339.5 2249 L 345.5 2242 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 78.5 2253 L 81.5 2257 L 78.5 2253 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 2254.5 2253 L 2251.5 2257 L 2254.5 2253 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 397.5 2287 L 396.5 2289 L 397.5 2287 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 385.5 2299 L 384.5 2301 L 385.5 2299 Z"
          fill="currentColor"
          fillOpacity="0.5137255"
          stroke="currentColor"
          strokeOpacity="0.5137255"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 2233.5 0 L 2237 0.5 L 2233.5 1 L 2233.5 0 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 102.5 68 L 2138 68.5 L 102.5 69 L 102.5 68 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 0.5 100 L 1 2232.5 L 0 2232.5 L 0.5 100 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 2332.5 101 L 2333 116.5 L 2332 116.5 L 2332.5 101 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 171.5 211 L 172 1923.5 L 171 1923.5 L 171.5 211 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 240.5 248 L 2092.5 248 L 2094 249.5 L 2093.5 457 L 2093 249 L 240.5 249 L 240.5 248 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 1095.5 409 L 1238.5 409 L 1240 410.5 L 1239.5 612 L 1239 410 L 1095.5 410 L 1095.5 409 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 1456.5 436 L 1457 456.5 L 1456 456.5 L 1456.5 436 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 876.5 438 L 877 456.5 L 876 456.5 L 876.5 438 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 2332.5 439 L 2333 457.5 L 2332 457.5 L 2332.5 439 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 946.5 454 L 1026 454.5 L 946.5 455 L 946.5 454 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 1308.5 454 L 1388 454.5 L 1308 455 L 1307.5 526 L 1307 455.5 L 1308.5 454 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 1079.5 680 L 1082 680.5 L 1079.5 681 L 1079.5 680 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 1252.5 680 L 1255 680.5 L 1252.5 681 L 1252.5 680 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 1165.5 770 L 1169 770.5 L 1165.5 771 L 1165.5 770 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 1163.5 847 L 1171 847.5 L 1163.5 848 L 1163.5 847 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 443.5 1685 L 972 1685.5 L 443.5 1686 L 443.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 1362.5 1685 L 1892 1685.5 L 1362.5 1686 L 1362.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 1977.5 1772 L 1978 1885.5 L 1977 1885.5 L 1977.5 1772 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 204.5 1955 L 2130 1955.5 L 204.5 1956 L 204.5 1955 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 485.5 2107 L 1849 2107.5 L 485.5 2108 L 485.5 2107 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 492.5 2175 L 1842 2175.5 L 492.5 2176 L 492.5 2175 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 2332.5 2183 L 2333 2232.5 L 2332 2232.5 L 2332.5 2183 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 96.5 2333 L 100 2333.5 L 96.5 2334 L 96.5 2333 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 301.5 2333 L 305 2333.5 L 301.5 2334 L 301.5 2333 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 2028.5 2333 L 2032 2333.5 L 2028.5 2334 L 2028.5 2333 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 2233.5 2333 L 2237 2333.5 L 2233.5 2334 L 2233.5 2333 Z"
          fill="currentColor"
          fillOpacity="0.5019608"
          stroke="currentColor"
          strokeOpacity="0.5019608"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'ThreeDPrinter')

export default icon
